import { Loader2, X } from 'lucide-react'
import type { SmartSearchApplied } from './smart-search-api'

export type SmartStatus = 'idle' | 'pending' | 'error' | 'ready'

export function SmartSearchStrip({
  status,
  pendingQuery,
  applied,
  relaxed = [],
  onRemove,
}: {
  status: SmartStatus
  pendingQuery?: string
  applied: SmartSearchApplied[]
  /** Filters that matched nothing together and were searched as words instead. */
  relaxed?: SmartSearchApplied[]
  onRemove: (item: SmartSearchApplied) => void
}) {
  return (
    <div className="sf-smart" data-e2e="smart-filters">
      <div className="sf-smart__result" aria-live="polite">
        {status === 'pending' ? (
          <span className="sf-smart__status">
            <Loader2 className="sf-smart__spinner" size={16} aria-hidden="true" />
            Choosing filters for “{pendingQuery}”…
          </span>
        ) : null}
        {status === 'error' ? (
          <span className="sf-smart__status sf-smart__status--error" role="alert">
            Smart filters didn’t answer. Showing a word search instead.
          </span>
        ) : null}
        {status === 'ready' && (applied.length || relaxed.length) ? (
          <ul className="sf-smart__chips" aria-label="Smart filters applied">
            {applied.map((item) => (
              <li key={`${item.kind}:${item.key}`}>
                <button
                  type="button"
                  className="sf-smart__chip"
                  onClick={() => onRemove(item)}
                  aria-label={`Remove ${item.label}: ${item.value}`}
                  title={`${Math.round(item.confidence * 100)}% sure`}
                >
                  <span className="sf-smart__chip-label">{item.label}</span>
                  <span className="sf-smart__chip-value">{item.value}</span>
                  <span className="sf-smart__chip-confidence">
                    {Math.round(item.confidence * 100)}%
                  </span>
                  <X size={14} aria-hidden="true" />
                </button>
              </li>
            ))}
            {relaxed.map((item) => (
              <li key={`relaxed:${item.key}`}>
                <span
                  className="sf-smart__chip sf-smart__chip--relaxed"
                  title="No products matched this filter, so its words are searched instead"
                >
                  <span className="sf-smart__chip-label">{item.label}</span>
                  <s className="sf-smart__chip-value">{item.value}</s>
                  <span className="sf-smart__chip-note">no matches</span>
                </span>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  )
}
